module.exports = __webpack_public_path__ + "static/img/118.c111c6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200921/118.jpg
// module id = +Ork
// module chunks = 0